<template>
    <div class="tags">
        <span class="single--tag" :value="tag.id" v-for="tag in tags"  v-if="tag.language_id == languageId">{{ tag.name }}</span>
    </div>
</template>
<script>
    export default {
        props: ['tags', 'languageId']
    }
</script>
